import React, { useEffect, useState, useContext } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ApiCall from '../../utils/Api';
import Edit_Admin_profile from '../../screens/profile/Edit_Admin_profile';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import Swal from 'sweetalert2';
import {convertDateFormat, extractTimeFromTimestamp} from "../../utils/services";
import { LangContext } from '../../utils/contaxt';

export default function AdminProfileTable() {
  const { lang, first_Name, Last_Name, setlang, setfirst_Name, setLast_Name } = useContext(LangContext);
  const [UpdateCount, setUpdateCount] = useState(0);
  const [ConsumerData, setConsumerData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const viewAccounts = async () => {
    try {
      const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
      let WalletsIds = data.data.data || [];
      let connectedAccounts = [];
      
      if (window.ethereum) {
        try {
          connectedAccounts = await window.ethereum.request({ method: 'eth_accounts' });
        } catch (error) {
          // MetaMask is not connected, but we can still show wallet addresses
        }
      }
      
      Swal.fire({
        title: "Wallet Addresses",
        html: `
          <div style="max-height: 400px; overflow-y: auto; padding: 30px">
            <ul style="list-style-type: none; padding: 0; margin: 0;">
              ${WalletsIds.map((item) => {
                const isConnected = connectedAccounts.some((item2) => item2.toLowerCase() === item.toLowerCase());
                const statusHTML = isConnected 
                  ? '<span style="font-size: 12px; color: green;">Connected</span>'
                  : '';
                return `<li style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                  <span>${item}</span>
                  ${statusHTML}
                </li>`;
              }).join("")}
            </ul>
          </div>
        `,
        width: '800px',
        showCloseButton: true,
        showConfirmButton: false,
      });
    } catch (error) {
      toast.error("Failed to load wallet addresses");
    }
  };

  const getConsumerData = async () => {
    try {
      const data = await ApiCall.SECURE_API.get("/admin/adminProfile");
      const profileData = data.data.data;
      
      setConsumerData(profileData);
      setIsLoading(false);
      
      // Set profile data in context for header display (image will be shown in header, not in table)
      const defaultImage = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';
      const profileImage = profileData?.profileImage;
      
      // Check if profileImage is a valid URL
      const isValidUrl = profileImage && 
                        typeof profileImage === 'string' &&
                        profileImage.trim() !== '' && 
                        profileImage !== 'null' && 
                        profileImage !== 'undefined' &&
                        (profileImage.startsWith('http://') || 
                         profileImage.startsWith('https://') || 
                         profileImage.startsWith('data:') ||
                         profileImage.startsWith('/'));
      
      // Always set an image in context for header display (either profile image or default)
      const imageToUse = isValidUrl ? profileImage : defaultImage;
      setlang(imageToUse);
      localStorage.setItem("image", imageToUse);
      
      // Update name in context for header display
      if (profileData?.firstName) {
        setfirst_Name(profileData.firstName);
      }
      if (profileData?.lastName) {
        setLast_Name(profileData.lastName);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching admin profile:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to load profile data");
      }
    }
  };

  useEffect(() => {
    getConsumerData();
  }, [UpdateCount]);

  return (
    <TableContainer style={{borderRadius:9}} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{backgroundColor:"Black"}}>
          <TableRow>
            <TableCell align="center" style={{color:"white"}}>Created At</TableCell>
            <TableCell align="center" style={{color:"white"}}>First Name</TableCell>
            <TableCell align="center" style={{color:"white"}}>Last Name</TableCell>
            <TableCell align="center" style={{color:"white"}}>Email</TableCell>
            <TableCell align="center" style={{color:"white"}}>Wallet Addresses</TableCell>
            <TableCell align="center" style={{color:"white"}}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isLoading && ConsumerData && Object.keys(ConsumerData).length > 0 ? (
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <span style={{fontWeight:600}}>{convertDateFormat(ConsumerData?.createdAt)}</span>
                  <span style={{color:"gray"}}>{extractTimeFromTimestamp(ConsumerData?.createdAt)}</span>
                </div>
              </TableCell>
              <TableCell align="center">
                {ConsumerData?.firstName || '-'}
              </TableCell>
              <TableCell align="center">
                {ConsumerData?.lastName || '-'}
              </TableCell>
              <TableCell align="center">
                {ConsumerData?.email || '-'}
              </TableCell>
              <TableCell align="center">
                <Button
                  onClick={viewAccounts}
                  variant="outlined"
                  size="small"
                >
                  View Accounts
                </Button>
              </TableCell>
              <TableCell align="center">
                <Edit_Admin_profile
                  imgurl={ConsumerData.profileImage}
                  firstName={ConsumerData.firstName}
                  lastName={ConsumerData.lastName}
                  email={ConsumerData.email}
                  UpdateCount={UpdateCount}
                  setUpdateCount={setUpdateCount}
                />
              </TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center" style={{padding: '40px'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <div style={{fontSize: '16px', color: '#666', marginBottom: '10px'}}>
                    {isLoading ? 'Loading profile data...' : 'No profile data available'}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}